import React from 'react';
import PublicPageLayout from '../components/marketing/PublicPageLayout';
import ApiReferenceDocs from '../components/api-reference/ApiReferenceDocs';

const APis = () => (
  <PublicPageLayout>
    <ApiReferenceDocs showHero />
  </PublicPageLayout>
);

export default APis;
